import React, { Component } from "react";
import { Row, Col, Card, CardBody, Container, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import classnames from 'classnames';
import { connect } from "react-redux";
import { changeSidebarTheme } from "../../store/actions";
import ConfigTable from './ConfigTable';
import ConfigTableTask from './ConfigTableTask';

class Configurations extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showEasing : "swing",
            hideEasing : "linear",
            showMethod : "fadeIn",
            hideMethod : "fadeOut",

            showDuration : 300,
            hideDuration : 1000,
            timeOut : 5000,
            extendedTimeOut : 1000,

            activeTab: '1',
            activeTabEducation: '1',
            activeTabWork: '1',
            activeTabEmployer: '1',
            activeTabSocial: '1',

            selectedGroup: null,

            customchk1: true,
            customchk2: false,
            customchk3: false,

        };

        this.changeLeftSidebarTheme = this.changeLeftSidebarTheme.bind(this);

        this.toggleTab = this.toggleTab.bind(this);
        this.toggleTabEducation = this.toggleTabEducation.bind(this);
        this.toggleTabWork = this.toggleTabWork.bind(this);
        this.toggleTabEmployer = this.toggleTabEmployer.bind(this);
        this.toggleTabSocial = this.toggleTabSocial.bind(this);

        this.handleSelectGroup = this.handleSelectGroup.bind(this);
    }

    toggleTab(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab,
            });
        }
    }

    toggleTabEducation(tab) {
        if (this.state.activeTabEducation !== tab) {
            this.setState({
                activeTabEducation: tab,
            });
        }
    }

    toggleTabWork(tab) {
        if (this.state.activeTabWork !== tab) {
            this.setState({
                activeTabWork: tab,
            });
        }
    }

    toggleTabEmployer(tab) {
        if (this.state.activeTabEmployer !== tab) {
            this.setState({
                activeTabEmployer: tab,
            });
        }
    }

    toggleTabSocial(tab) {
        if (this.state.activeTabSocial !== tab) {
            this.setState({
                activeTabSocial: tab,
            });
        }
    }

    handleSelectGroup = selectedGroup => {
        this.setState({ selectedGroup });
    };

    changeLeftSidebarTheme(color) {
        this.props.changeSidebarTheme(color);
        localStorage.setItem("color", color)
    }

    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid={true}>
                        <Breadcrumbs title="Menu" breadcrumbItem="Konfigurime" />
                    
                        <div className="checkout-tabs">
                            <Row>
                                <Col lg="2">
                                    <Nav className="flex-column" pills>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: this.state.activeTab === '1' })}
                                                onClick={() => { this.toggleTab('1'); }}
                                            >
                                                <i className="bx bxs-graduation d-block check-nav-icon mt-4 mb-2"></i>
                                                <p className="font-weight-bold mb-4">Education</p>
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: this.state.activeTab === '2' })}
                                                onClick={() => { this.toggleTab('2'); }}
                                            >
                                                <i className="bx bx-briefcase d-block check-nav-icon mt-4 mb-2"></i>
                                                <p className="font-weight-bold mb-4">Punësimi</p>
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: this.state.activeTab === '3' })}
                                                onClick={() => { this.toggleTab('3'); }}
                                            >
                                                <i className="bx bxs-user-badge d-block check-nav-icon mt-4 mb-2"></i>
                                                <p className="font-weight-bold mb-4">Rolet dhe Kontributet</p>
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: this.state.activeTab === '4' })}
                                                onClick={() => { this.toggleTab('4'); }}
                                            >
                                                <i className="bx bx-globe d-block check-nav-icon mt-4 mb-2"></i>
                                                <p className="font-weight-bold mb-4">Detyrat dhe Social</p>
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                </Col>

                                <Col lg="10">
                                    <Card>
                                        <CardBody>
                                            <TabContent activeTab={this.state.activeTab}>
                                                
                                                <TabPane tabId="1" id="v-pills-payment" role="tabpanel" aria-labelledby="v-pills-payment-tab">
                                                    <Nav className="flex-row" pills>
                                                        <NavItem>
                                                            <NavLink
                                                                className={classnames({ active: this.state.activeTabEducation === '1' })}
                                                                onClick={() => {

                                                                    this.toggleTabEducation('1'); }}
                                                            >
                                                                <p className="font-weight-bold mb-4">Niveli i Edukimit</p>
                                                            </NavLink>
                                                        </NavItem>
                                                        
                                                        <NavItem>
                                                            <NavLink
                                                                className={classnames({ active: this.state.activeTabEducation === '2' })}
                                                                onClick={() => { this.toggleTabEducation('2'); }}
                                                            >
                                                                <p className="font-weight-bold mb-4">Lloji i Edukimit</p>
                                                            </NavLink>
                                                        </NavItem>
                                                        
                                                    </Nav>

                                                    <TabContent activeTab={this.state.activeTabEducation}>
                                                        <TabPane  tabId="1">
                                                            <div style={{ maxWidth: "100%" }}>
                                                                <ConfigTable
                                                                    title='Niveli i Edukimit'
                                                                    endpoint='/api/hr/educationlevel'
                                                                />
                                                            </div>                                                        
                                                        </TabPane>
                                                        <TabPane tabId="2">
                                                            <div style={{ maxWidth: "100%" }}>  
                                                                <ConfigTable
                                                                    title='Lloji i Edukimit'
                                                                    endpoint='/api/hr/education'
                                                                />
                                                            </div>
                                                        </TabPane>
                                                    </TabContent>
                                                </TabPane>
                                                
                                                <TabPane tabId="2" id="v-pills-confir" role="tabpanel">
                                                    <Nav className="flex-row" pills>
                                                        <NavItem>
                                                            <NavLink
                                                                className={classnames({ active: this.state.activeTabWork === '1' })}
                                                                onClick={() => { this.toggleTabWork('1'); }}
                                                            >
                                                                <p className="font-weight-bold mb-4">Statusi i Punës</p>
                                                            </NavLink>
                                                        </NavItem>

                                                        <NavItem>
                                                            <NavLink
                                                                className={classnames({ active: this.state.activeTabWork === '2' })}
                                                                onClick={() => { this.toggleTabWork('2'); }}
                                                            >
                                                                <p className="font-weight-bold mb-4">Lloji i Punëdhënësit</p>
                                                            </NavLink>
                                                        </NavItem>
                                                        
                                                        <NavItem>
                                                            <NavLink
                                                                className={classnames({ active: this.state.activeTabWork === '3' })}
                                                                onClick={() => { this.toggleTabWork('3'); }}
                                                            >
                                                                <p className="font-weight-bold mb-4">Emri i Punëdhënësit</p>
                                                            </NavLink>
                                                        </NavItem>
                                                        
                                                    </Nav>

                                                    <TabContent activeTab={this.state.activeTabWork}>
                                                        <TabPane tabId="1">
                                                            <div style={{ maxWidth: "100%" }}>  
                                                            <ConfigTable
                                                                title='Statusi i Punës'
                                                                endpoint='/api/hr/employmentstatus'
                                                            />
                                                        </div>
                                                        </TabPane>
                                                    
                                                        <TabPane tabId="2">
                                                            <div style={{ maxWidth: "100%" }}>
                                                                <ConfigTable
                                                                    title='Lloji i Punëdhënësit'
                                                                    endpoint='/api/hr/employertype'
                                                                />
                                                            </div>
                                                        </TabPane>

                                                        <TabPane tabId="3">
                                                            <div style={{ maxWidth: "100%" }}>  
                                                                <ConfigTable
                                                                    title='Emri i Punëdhënësit'
                                                                    endpoint='/api/hr/employer'
                                                                />
                                                            </div>
                                                        </TabPane>
                                                    </TabContent>
                                                </TabPane>

                                                <TabPane tabId="3" id="v-pills-confir" role="tabpanel">
                                                    <Nav className="flex-row" pills>
                                                        <NavItem>
                                                            <NavLink
                                                                className={classnames({ active: this.state.activeTabEmployer === '1' })}
                                                                onClick={() => { this.toggleTabEmployer('1'); }}
                                                            >
                                                                <p className="font-weight-bold mb-4">Roli në Sistem</p>
                                                            </NavLink>
                                                        </NavItem>

                                                        <NavItem>
                                                            <NavLink
                                                                className={classnames({ active: this.state.activeTabEmployer === '2' })}
                                                                onClick={() => { this.toggleTabEmployer('2'); }}
                                                            >
                                                                <p className="font-weight-bold mb-4">Roli në Anëtarësi</p>
                                                            </NavLink>
                                                        </NavItem>
                                                        
                                                        <NavItem>
                                                            <NavLink
                                                                className={classnames({ active: this.state.activeTabEmployer === '3' })}
                                                                onClick={() => { this.toggleTabEmployer('3'); }}
                                                            >
                                                                <p className="font-weight-bold mb-4">Kontributet</p>
                                                            </NavLink>
                                                        </NavItem>

                                                        <NavItem>
                                                            <NavLink
                                                                className={classnames({ active: this.state.activeTabEmployer === '4' })}
                                                                onClick={() => { this.toggleTabEmployer('4'); }}
                                                            >
                                                                <p className="font-weight-bold mb-4">Organizatat</p>
                                                            </NavLink>
                                                        </NavItem>

                                                        
                                                    </Nav>

                                                    <TabContent activeTab={this.state.activeTabEmployer}>
                                                        <TabPane tabId="1">
                                                            <div style={{ maxWidth: "100%" }}>
                                                                <ConfigTable
                                                                    title='Rolet'
                                                                    endpoint='/api/hr/memberrole'
                                                                />
                                                            </div>
                                                        </TabPane>

                                                        <TabPane tabId="2">
                                                            <div style={{ maxWidth: "100%" }}>
                                                                <ConfigTable
                                                                    title='Kontributet'
                                                                    endpoint='/api/hr/partyrole'
                                                                />
                                                            </div>
                                                        </TabPane>

                                                        <TabPane tabId="3">
                                                            <div style={{ maxWidth: "100%" }}>
                                                                <ConfigTable
                                                                    title='Kontributet'
                                                                    endpoint='/api/hr/contributetype'
                                                                />
                                                            </div>
                                                        </TabPane>

                                                        <TabPane tabId="4">
                                                            <div style={{ maxWidth: "100%" }}>
                                                                <ConfigTable
                                                                    title='Organizata'
                                                                    endpoint='/api/hr/organisation'
                                                                />
                                                            </div>
                                                        </TabPane>
                                                    </TabContent>
                                                </TabPane>

                                                <TabPane tabId="4" id="v-pills-confir" role="tabpanel">

                                                    <Nav className="flex-row" pills>
                                                        <NavItem>
                                                            <NavLink
                                                                className={classnames({ active: this.state.activeTabSocial === '1' })}
                                                                onClick={() => { this.toggleTabSocial('1'); }}
                                                            >
                                                                <p className="font-weight-bold mb-4">Detyrat</p>
                                                            </NavLink>
                                                        </NavItem>
                                                        
                                                        <NavItem>
                                                            <NavLink
                                                                className={classnames({ active: this.state.activeTabSocial === '2' })}
                                                                onClick={() => { this.toggleTabSocial('2'); }}
                                                            >
                                                                <p className="font-weight-bold mb-4">Social</p>
                                                            </NavLink>
                                                        </NavItem>
                                                        
                                                    </Nav>

                                                    <TabContent activeTab={this.state.activeTabSocial}>
                                                        <TabPane tabId="1">
                                                            <div style={{ maxWidth: "100%" }}>
                                                                <ConfigTableTask
                                                                    title='Detyrat'
                                                                    endpoint='/api/hr/tasktype'
                                                                />
                                                            </div>
                                                        </TabPane>

                                                        <TabPane tabId="2">
                                                            <div style={{ maxWidth: "100%" }}>
                                                                <ConfigTable
                                                                    title='Social'
                                                                    endpoint='/api/social/socialmedia'
                                                                />
                                                            </div>
                                                        </TabPane>
                                                    </TabContent>
                                                </TabPane>
                                            </TabContent>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    return { ...state.Layout };
};

export default connect(mapStatetoProps, {
    changeSidebarTheme,
})(Configurations);

